import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  onChange(e) {
    if (e.currentTarget.checked) {
      this.checkboxTargets.forEach((checkbox) => {
        if (checkbox.checked && checkbox !== e.currentTarget) checkbox.checked = false
      })
    }
  }
}
